/**
 * Compute the geographic center (bounding box center) of a GeoJSON feature.
 * Returns [lng, lat] or null if the feature has no usable geometry.
 *
 * Lighter than a true polygon centroid — enough for placing a UI marker
 * (loading spinner, region label) without pulling in turf.
 */
export function featureBboxCenter(feature: GeoJSON.Feature): [number, number] | null {
  let minX = Infinity,
    minY = Infinity,
    maxX = -Infinity,
    maxY = -Infinity;

  const visit = (coords: any) => {
    if (typeof coords[0] === 'number') {
      const [x, y] = coords;
      if (x < minX) minX = x;
      if (y < minY) minY = y;
      if (x > maxX) maxX = x;
      if (y > maxY) maxY = y;
      return;
    }
    for (const c of coords) visit(c);
  };

  if (!feature.geometry) return null;
  const g = feature.geometry as GeoJSON.Geometry & { coordinates?: any };
  if (!g.coordinates) return null;
  visit(g.coordinates);

  if (!isFinite(minX)) return null;
  return [(minX + maxX) / 2, (minY + maxY) / 2];
}
